import React, { useState, useEffect } from 'react';
import classes from './Navigator.module.css';
import { MdOutlineLeaderboard } from 'react-icons/md';
import { PiUserListBold } from 'react-icons/pi';
import { GoHome } from 'react-icons/go';
import { MdOutlineDateRange, MdOutlineSettings } from 'react-icons/md';
import { GoChevronRight, GoChevronLeft } from 'react-icons/go';

const Navigator = ({ active, handleClick }) => {
  const [showBar, setShowBar] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMounted, setIsMounted] = useState(true);

  // const handleToggleBar = () => {
  //   if (showBar) {
  //     // Start hiding animation
  //     setIsAnimating(true);
  //     setTimeout(() => {
  //       setIsMounted(false); // Unmount after animation completes
  //       setIsAnimating(false);
  //     }, 100); // Match this duration to your CSS transition time
  //   } else {
  //     setIsMounted(true); // Mount immediately before showing
  //     setTimeout(() => {
  //       setIsAnimating(true); // Start showing animation
  //     }, 10); // Add slight delay to trigger animation
  //   }
  //   setShowBar((prev) => !prev);
  // };

  return (
    <div className={classes['mainWrapper']}>
      {/* {isMounted && ( */}
      <div
        // className={`${classes.actionWrapper}
        // ${isAnimating && showBar ? classes['slideIn'] : classes['slideOut']}
        // `}
        className={classes.actionWrapper}>
        <span
          className={[classes['iconWrapper'], active === '' && classes['active']].join(' ')}
          onClick={() => handleClick('/statistics')}>
          <MdOutlineLeaderboard size={25} />
        </span>
        <span
          className={[classes['iconWrapper'], active === 'patient-list' && classes['active']].join(
            ' '
          )}
          onClick={() => handleClick('/patient-list')}>
          <PiUserListBold style={{ transform: 'rotateY(180deg)' }} size={25} />
        </span>
        <span
          className={[classes['iconWrapper'], active === 'dashboard' && classes['active']].join(
            ' '
          )}
          onClick={() => handleClick('/dashboard')}>
          <GoHome size={25} style={{ strokeWidth: '0.7px' }} />
        </span>
        <span
          className={[classes['iconWrapper'], active === 'appointments' && classes['active']].join(
            ' '
          )}
          onClick={() => handleClick('/appointments')}>
          <MdOutlineDateRange size={25} />
        </span>
        <span
          className={[classes['iconWrapper'], active === 'settings' && classes['active']].join(' ')}
          onClick={() => handleClick('/settings')}>
          <MdOutlineSettings size={25} />
        </span>
        {/* <div className={classes.line}></div> */}
      </div>
      {/* )} */}
      {/* <span className={[classes['iconWrapper']].join(' ')} onClick={handleToggleBar}>
        {showBar ? <GoChevronRight size={25} /> : <GoChevronLeft size={25} />}
      </span> */}
    </div>
  );
};

export default Navigator;
